class MoonCalculator {
  constructor() {

    // console.log('moon phase finder', this.moonPhaseFinder);

    // Initialize properties
    // this.MoonCalendarDate = this.querySelector('#moon-calendar-date');
    // this.MoonCalendarData = this.querySelector('#moon-calendar-data');
    // this.form = this.querySelector('#moon-calendar-form');
    // this.birthstone = this.querySelector('#birthstone');
    // this.moonphase = this.querySelector('#moonphase');
    // this.zodiac = this.querySelector('#zodiac');
    // this.element = this.querySelector('#element');
    // this.animal = this.querySelector('#animal');
    // this.submitButton = this.querySelector('#submit');
    // this.closeButton = this.querySelector('#close');
    // this.datePicker = this.querySelector('.date-picker');
  }

  static getMonthName(month) {
    // Map months to their names
    const months = {
      1: "January",
      2: "February",
      3: "March",
      4: "April",
      5: "May",
      6: "June",
      7: "July",
      8: "August",
      9: "September",
      10: "October",
      11: "November",
      12: "December"
    };

    return months[month] || "Unknown";  // Return the month name or 'Unknown' if month is invalid
  }

  static getComposedData(date) {
    // Year date
    // Moon phase data
    // Birthstone data
    // Zodiac data
    // Zodiac element data
    return {
      date: date,
      moonPhase: MoonCalculator.fetchCalendarData(date),
      birthstone: MoonCalculator.getBirthstoneFromDate(date),
    }
  }

  static async fetchCalendarData(targetDate) {
    try {
      const response = await fetch('https://cdn.shopify.com/s/files/1/0644/7238/3733/files/calendar-data.json');
      if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const rawData = await response.text();

        try {
            const jsonData = JSON.parse(rawData);
            // Define the date you're searching for

            // if target date first char is 0, remove it
            if (targetDate.charAt(0) === '0') {
              targetDate = targetDate.slice(1);
            }

            // Check if the date exists in the JSON object
            if (jsonData.hasOwnProperty(targetDate)) {
              console.log(`Event on ${targetDate}:`, jsonData[targetDate]);
              // this.moonphase.innerText = jsonData[targetDate];
              return jsonData[targetDate];
            } else {
              console.log(`No event found for date: ${targetDate}`);
            }
        } catch (jsonError) {
            console.error('Error parsing JSON:', jsonError);
        }

    } catch (error) {
        console.error('There has been a problem with your fetch operation:', error);
    }
  }

  static getZodiacSign(day, month) {
    // Zodiac signs and date ranges
    if ((month == 3 && day >= 21) || (month == 4 && day <= 19)) {
        return "Aries";
    } else if ((month == 4 && day >= 20) || (month == 5 && day <= 20)) {
        return "Taurus";
    } else if ((month == 5 && day >= 21) || (month == 6 && day <= 20)) {
        return "Gemini";
    } else if ((month == 6 && day >= 21) || (month == 7 && day <= 22)) {
        return "Cancer";
    } else if ((month == 7 && day >= 23) || (month == 8 && day <= 22)) {
        return "Leo";
    } else if ((month == 8 && day >= 23) || (month == 9 && day <= 22)) {
        return "Virgo";
    } else if ((month == 9 && day >= 23) || (month == 10 && day <= 22)) {
        return "Libra";
    } else if ((month == 10 && day >= 23) || (month == 11 && day <= 21)) {
        return "Scorpio";
    } else if ((month == 11 && day >= 22) || (month == 12 && day <= 21)) {
        return "Sagittarius";
    } else if ((month == 12 && day >= 22) || (month == 1 && day <= 19)) {
        return "Capricorn";
    } else if ((month == 1 && day >= 20) || (month == 2 && day <= 18)) {
        return "Aquarius";
    } else if ((month == 2 && day >= 19) || (month == 3 && day <= 20)) {
        return "Pisces";
    }
    return null; // In case the date is invalid
  }

  static getZodiacElement(zodiacSign) {
    // Map zodiac signs to their elements
    const elements = {
      Aries: "Fire",
      Leo: "Fire",
      Sagittarius: "Fire",
      Taurus: "Earth",
      Virgo: "Earth",
      Capricorn: "Earth",
      Gemini: "Air",
      Libra: "Air",
      Aquarius: "Air",
      Cancer: "Water",
      Scorpio: "Water",
      Pisces: "Water"
    };

    return elements[zodiacSign] || "Unknown";
  }

  // Function to get zodiac element based on a date
  static getZodiacElementFromDate(day, month) {
      const zodiacSign = MoonCalculator.getZodiacSign(day, month);

      if (zodiacSign) {
          const element = MoonCalculator.getZodiacElement(zodiacSign);
          return {
            zodiacSign: zodiacSign,
            element: element
          }
      } else {
          console.log("Invalid date.");
          return null;
      }
  }

  static getMoonPhaseName(phase) {
    const moonPhases = {
      "NM":"New Moon",
      "1WX":"Waxing Crescent",
      "2WX":"Waxing Crescent",
      "3WX":"Waxing Crescent",
      "4WX":"Waxing Crescent",
      "FQ":"First Quarter",
      "5WX":"Waxing Gibbous",
      "6WX":"Waxing Gibbous",
      "7WX":"Waxing Gibbous",
      "8WX":"Waxing Gibbous",
      "FM":"Full Moon",
      "1WN":"Waning Gibbous",
      "2WN":"Waning Gibbous",
      "3WN":"Waning Gibbous",
      "4WN":"Waning Gibbous",
      "LQ":"Last Quarter",
      "5WN":"Waning Crescent",
      "6WN":"Waning Crescent",
      "7WN":"Waning Crescent",
      "8WN":"Waning Crescent"
    };

    return moonPhases[phase] || "Unknown";
  }

  static getBirthstone(month) {
    // Map months to their respective birthstones
    const birthstones = {
        1: "Garnet",             // January
        2: "Amethyst",           // February
        3: "Aquamarine",         // March
        4: "Diamond",            // April
        5: "Emerald",            // May
        6: "Pearl or Alexandrite",// June
        7: "Ruby",               // July
        8: "Peridot",            // August
        9: "Sapphire",           // September
        10: "Opal or Tourmaline",// October
        11: "Topaz or Citrine",  // November
        12: "Turquoise or Blue Topaz" // December
    };

    return birthstones[month] || "Unknown";  // Return the birthstone or 'Unknown' if month is invalid
}

// static getChineseZodiacAnimal(year) {
//   // List of zodiac animals in the order of their cycle
//   const zodiacAnimals = [
//       "Rat",    // 0
//       "Ox",     // 1
//       "Tiger",  // 2
//       "Rabbit", // 3
//       "Dragon", // 4
//       "Snake",  // 5
//       "Horse",  // 6
//       "Goat",   // 7
//       "Monkey", // 8
//       "Rooster",// 9
//       "Dog",    // 10
//       "Pig"     // 11
//   ];

//   // Calculate the zodiac animal by using modulus operation
//   const zodiacIndex = (year - 4) % 12; // 4 is the base year for Rat (2020)
//   return zodiacAnimals[zodiacIndex];
// }

// Function to get zodiac animal based on birth year
// static getAnimalFromDate(year) {
//   const animal = getChineseZodiacAnimal(year);

//   if (animal) {
//       console.log(`Year: ${year}, Zodiac Animal: ${animal}`);
//       return animal;
//   } else {
//       console.log("Invalid year.");
//       return null;
//   }
// }

// Function to get the birthstone from a date (day and month)
static getBirthstoneFromDate(month) {
  const birthstone = MoonCalculator.getBirthstone(month);

  if (birthstone) {
    console.log(`Month: ${month}, Birthstone: ${birthstone}`);
    return birthstone;
  } else {
    console.log("Invalid date.");
    return null;
  }
}

}
const moonCalculator = new MoonCalculator();

document.addEventListener("DOMContentLoaded", () => {
  const moonInput = document.getElementById("moon-code-input");
  const animalInput = document.getElementById("chinese-animal-input");
  const dayInput = document.getElementById("day-of-week-input");
  const dateInput = document.querySelector(".date-picker");
  const calendarScript = document.getElementById("calendar-data");

  if (!moonInput || !animalInput || !dateInput || !calendarScript) return;

  fetch(calendarScript.getAttribute("src"))
    .then(response => response.json())
    .then(calendarData => {

      function parseDateString(dateStr) {
        // Supports DD-MM-YYYY, D-M-YYYY, YYYY-MM-DD, etc.
        const parts = dateStr.includes('-')
          ? dateStr.split('-')
          : dateStr.split('/');

        if (parts.length !== 3) return null;

        let day, month, year;
        if (parts[0].length === 4) {
          // Format: YYYY-MM-DD
          year = parseInt(parts[0]);
          month = parseInt(parts[1]);
          day = parseInt(parts[2]);
        } else {
          // Format: DD-MM-YYYY
          day = parseInt(parts[0]);
          month = parseInt(parts[1]);
          year = parseInt(parts[2]);
        }

        return { day, month, year };
      }

      function getMoonCode({ day, month, year }) {
        const key = `${day}-${month}-${year}`;
        const code = calendarData[key] || "Unknown";
        console.log(`🌙 Moon Lookup Key: ${key} → ${code}`);
        return code;
      }

      function getZodiacAnimal(year) {
        const animals = [
          "Rat", "Ox", "Tiger", "Rabbit", "Dragon", "Snake",
          "Horse", "Goat", "Monkey", "Rooster", "Dog", "Pig"
        ];
        if (isNaN(year)) return "Unknown";
        return animals[(year - 1900) % 12] || "Unknown";
      }

      function updateInputs(dateStr) {
  const parsed = parseDateString(dateStr);
  if (!parsed) return;

  const moonCode = getMoonCode(parsed);
  const animal = getZodiacAnimal(parsed.year);
  const dateObj = new Date(`${parsed.year}-${parsed.month}-${parsed.day}`);
  const weekday = dateObj.toLocaleDateString("en-AU", { weekday: "long" });

  moonInput.value = moonCode;
  animalInput.value = animal;
  dayInput.value = weekday;

  console.log("✅ Final result:");
  console.log("  🌙 Moon Code:", moonCode);
  console.log("  🐉 Chinese Animal:", animal);
  console.log("  📅 Day of Week:", weekday);
}

      if (dateInput.value) updateInputs(dateInput.value);

      dateInput.addEventListener("change", () => {
        updateInputs(dateInput.value);
      });

    })
    .catch(err => {
      console.error("❌ Failed to load calendar data:", err);
    });
});
